import { render, staticRenderFns } from "./CourseBox.vue?vue&type=template&id=0f55f09a&scoped=true"
import script from "./CourseBox.vue?vue&type=script&lang=js"
export * from "./CourseBox.vue?vue&type=script&lang=js"
import style0 from "./CourseBox.vue?vue&type=style&index=0&id=0f55f09a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f55f09a",
  null
  
)

export default component.exports